import { AxiosError } from "axios";

export function isAxiosErrorOfStatus(error: unknown, status: number): error is AxiosError {
    return error instanceof AxiosError && error.response?.status === status;
}
